/*
 * buy-price-quantity.js
 * Makes the Add-to-cart button price reflect the quantity the customer selects.
 *
 * Behaviour (per merchant request):
 *   Button price = volume-tier unit price for the current quantity  x  quantity
 *   i.e. the actual line total that will be added to the cart, including any
 *   B2B / volume (quantity break) discount.
 *
 * Only affects <product-buy-price> elements that carry a data-volume-tiers
 * attribute (rendered by snippets/buy-buttons.liquid). Product-bundle buy
 * prices do not have that attribute and are therefore left untouched.
 */
(function () {
  if (window.__buyPriceQtyInit) return;
  window.__buyPriceQtyInit = true;

  function moneyFormat() {
    return theme.settings.currencyCodeEnabled
      ? theme.settings.moneyWithCurrencyFormat
      : theme.settings.moneyFormat;
  }

  function parseTiers(el) {
    try {
      // [[minQty, unitPriceInCents], ...]
      return JSON.parse(el.getAttribute('data-volume-tiers') || '[]');
    } catch (e) {
      return [];
    }
  }

  // Unit price (in cents) that applies for a given quantity.
  function unitPriceForQty(basePrice, tiers, qty) {
    var unit = basePrice;
    tiers
      .slice()
      .sort(function (a, b) { return a[0] - b[0]; })
      .forEach(function (tier) {
        if (qty >= tier[0]) unit = tier[1];
      });
    return unit;
  }

  // Find the quantity value for a given <product-buy-price> element's form.
  function quantityFor(buyPrice) {
    var formId = buyPrice.getAttribute('form');
    var input = formId
      ? document.querySelector('input[name="quantity"][form="' + formId + '"]')
      : null;
    var qty = input ? parseInt(input.value, 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function update(buyPrice, qtyOverride) {
    if (!buyPrice || !window.theme || !theme.Currency) return;
    var base = parseInt(buyPrice.getAttribute('data-price'), 10) || 0;
    var tiers = parseTiers(buyPrice);
    var qty = typeof qtyOverride === 'number' ? qtyOverride : quantityFor(buyPrice);
    var total = unitPriceForQty(base, tiers, qty) * qty;
    buyPrice.innerHTML = theme.Currency.formatMoney(total, moneyFormat());
  }

  function updateByForm(formId, qty) {
    if (!formId) return;
    document
      .querySelectorAll('product-buy-price[form="' + formId + '"][data-volume-tiers]')
      .forEach(function (el) { update(el, qty); });
  }

  // Live update whenever a quantity input changes (typing, blur, +/- buttons).
  function onQtyEvent(e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[name="quantity"]')) return;
    var qty = parseInt(t.value, 10);
    updateByForm(t.getAttribute('form'), isNaN(qty) || qty < 1 ? 1 : qty);
  }
  document.addEventListener('change', onQtyEvent);
  document.addEventListener('input', onQtyEvent);

  // Initial render (covers products whose minimum quantity is > 1) and
  // re-render after a variant switch replaces the button markup.
  function initAll() {
    document
      .querySelectorAll('product-buy-price[data-volume-tiers]')
      .forEach(function (el) { update(el); });
  }

  // The main theme bundle (theme.Currency / theme.pubsub) may still be loading
  // when this deferred script runs, so wait until it is ready.
  function themeReady() {
    return window.theme && theme.Currency && theme.settings;
  }

  function whenThemeReady(cb) {
    if (themeReady()) { cb(); return; }
    var tries = 0;
    var iv = setInterval(function () {
      if (themeReady()) { clearInterval(iv); cb(); }
      else if (++tries > 60) { clearInterval(iv); }
    }, 50);
  }

  whenThemeReady(function () {
    initAll();
    if (theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      // Re-render after the theme swaps in new variant markup.
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(initAll, 0);
      });
      // Re-render whenever the theme resets the quantity input value
      // programmatically (e.g. after add-to-cart or removing the item from
      // the cart). This event fires right after `input.value = min`, so the
      // value we read is already up to date (no change event is dispatched).
      if (theme.pubsub.PUB_SUB_EVENTS.quantityUpdate) {
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.quantityUpdate, function () {
          setTimeout(initAll, 0);
        });
      }
    }
  });
})();